import { createContext, useContext } from 'react';
import { Package, SelectedAdditionalCoverage } from '../interfaces/interfaces';

export interface IPackageContextProps {
    selectedPackage: Package;
    selectedDeductible: number;
    selectedPackageIndex: number;
    packages: Package[];
    additionalCoverages: string[];
    selectedAdditionalCoverages: SelectedAdditionalCoverage[];
}

const PackageContext = createContext<IPackageContextProps>({} as IPackageContextProps);
export { PackageContext };
export const usePackageContext = () => useContext(PackageContext);
